import { api } from '../api';

// Tipos exportados
export type ConnectionStatus = {
  instance: string;
  state: string;
  qrcode?: string;
  base64?: string;
};

export type ConnectionState = {
  instance: string;
  status: 'connected' | 'disconnected' | 'connecting' | 'unknown';
  lastUpdate: string;
  disconnectReason?: string;
};

export type DisconnectResponse = {
  success: boolean;
  message: string;
};

export type QueueInfo = {
  total: number;
  oldest: string | null;
  types: {
    text: number;
    button: number;
  };
};

export type QueueResponse = {
  success: boolean;
  queue: QueueInfo;
  connectionStatus: string;
};

export type ProcessQueueResult = {
  processed: number;
  failed: number;
  remaining: number;
};

// Serviço
export const whatsappService = {
  /**
   * Conecta a instância do WhatsApp e retorna QR Code se necessário
   */
  connect: () => api.get<ConnectionStatus>('/whatsapp/connect'),

  /**
   * Verifica o status da conexão via API do WhatsApp
   */
  getStatus: () => api.get<ConnectionStatus>('/whatsapp/status'),

  /**
   * Retorna o estado atual armazenado em memória (atualizado via webhook)
   */
  getCurrentState: () => api.get<ConnectionState>('/whatsapp/current-state'),

  /**
   * Desconecta a instância do WhatsApp
   */
  disconnect: () => api.delete<DisconnectResponse>('/whatsapp/disconnect'),

  /**
   * Retorna informações sobre a fila de mensagens
   */
  getQueue: () => api.get<QueueResponse>('/whatsapp/queue'),

  /**
   * Processa a fila de mensagens manualmente
   */
  processQueue: () => api.post<{ success: boolean; message: string; result: ProcessQueueResult }>('/whatsapp/queue/process'),

  /**
   * Limpa mensagens expiradas da fila
   */
  cleanExpiredMessages: () => api.delete<{ success: boolean; message: string; remaining: number }>('/whatsapp/queue/expired'),
};

